import React from 'react';
import { Box,
   Typography,
     Grid,
    //  useTheme 
    } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
import ReportCard from './ReportCard';

export default function ReportsGridPreview({ reports = [] }) {
  

  if (!Array.isArray(reports) || reports.length === 0) return null;

  
  return (
    <Box mt={5} >
      {!!reports && Array.isArray(reports) && reports.length > 0 ? (
        <Grid container spacing={3} justifyContent="center">
          {reports.map((report, idx) => (
            <ReportCard report={report} key={report?.report_id || idx} />
          ))}
        </Grid>
      ) : (
        <Typography
          variant="h6"
          fontWeight="bold"
          className="alert alert-warning"
          mb={2}
        >
          No Reports Found
        </Typography>
      )}
    </Box>
  );
}
